import React from "react";

const MiniNavbar = () => {
  return (
    <div className="font-molot">
      <div className="bg-[#112483] text-xl py-1 px-4 flex items-center justify-between">
        <div className="text-white hidden md:flex md:w-6/12 justify-center">
          CHARACTERS
        </div>

        <div className="flex-1 flex md:justify-start justify-center">
          <div className="text-white flex space-x-20">
            <a
              className="hover:text-[#9690EF]"
              href="https://pump.fun/FcypHMKoeToLtUwd5Zsd4gbUB7UEs7FtRfUEPXm8pump"
              target="_blank"
              rel="noopener noreferrer"
            >
              CHART
            </a>
            <a
              className="hover:text-[#9690EF]"
              href="https://pump.fun/FcypHMKoeToLtUwd5Zsd4gbUB7UEs7FtRfUEPXm8pump"
              target="_blank"
              rel="noopener noreferrer"
            >
              BUY
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniNavbar;
